export default "__VITE_ASSET__baf31af5__"